export default __webpack_public_path__ + "static/media/link2.724b72c3.png";